import { useState } from "react";
import { getMonth, getYear } from "date-fns";
import { ReactSVG } from "react-svg";
import IconCalendarArrow from "../../../public/images/calendar-arrow.svg";
import "../../datepicker.scss";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DatepickerHeader = (props: any) => {
  const [showMonthDropdown, setShowMonthDropdown] = useState<boolean>(false);
  const [showYearDropdown, setShowYearDropdown] = useState<boolean>(false);

  const yearRange = (start: number, end: number, step: number = 1) => {
    const years = [];
    for (let year = start; year <= end; year += step) {
      years.push(year);
    }
    return years;
  };

  const years: number[] = yearRange(1924, getYear(new Date()), 1);
  console.log(showYearDropdown, "showYearDropdown");

  const months: string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const {
    date,
    changeYear,
    changeMonth,
    // prevMonthButtonDisabled,
    // nextMonthButtonDisabled,
    // prevYearButtonDisabled,
    // nextYearButtonDisabled,
    isMonthYearPicker = false,
  } = props;

  const currentMonth: number = getMonth(new Date());
  const currentYear: number = getYear(new Date());

  return (
    <div className="theme-datepicker-header-selector">
      {!isMonthYearPicker && (
        <>
          <div
            className="theme-datepicker-header-month-selector"
            onClick={() => {
              setShowMonthDropdown(!showMonthDropdown);
              setShowYearDropdown(false);
            }}
          >
            <span>{months[getMonth(date)]}</span>
            <ReactSVG
              src={IconCalendarArrow}
              className={`arrow-icon ${showMonthDropdown && "is-active"}`}
            />
          </div>
          <div className="separator"></div>
          {showMonthDropdown && (
            <div className="theme-datepicker-dropdown month-selector">
              {months.map((month: string, index: number) => {
                return (
                  <span
                    key={`month-${index}`}
                    className={`theme-datepicker-dropdown-item ${
                      months[getMonth(date)] === month && "is-selected"
                    } ${currentMonth === index && "is-current"}`}
                    onClick={() => {
                      changeMonth(months.indexOf(month));
                      setShowMonthDropdown(false);
                    }}
                  >
                    {month}
                  </span>
                );
              })}
            </div>
          )}
        </>
      )}

      <div
        className="theme-datepicker-header-year-selector"
        onClick={() => {
          setShowYearDropdown(!showYearDropdown);
          setShowMonthDropdown(false);
        }}
      >
        <span>{getYear(date)}</span>
        <ReactSVG
          src={IconCalendarArrow}
          className={`arrow-icon ${showYearDropdown ? "is-active" : ""}`}
        />
      </div>
      {showYearDropdown && (
        <div className="theme-datepicker-dropdown year-selector">
          {years.map((year: number, index: number) => {
            return (
              <span
                key={`year-${index}`}
                className={`theme-datepicker-dropdown-item ${
                  getYear(date) === year && "is-selected"
                } ${currentYear === year && "is-current"}`}
                onClick={() => {
                  changeYear(year);
                  setShowYearDropdown(false);
                }}
              >
                {year}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DatepickerHeader;
